import { render, staticRenderFns } from "./VisorEvidencia.vue?vue&type=template&id=64d02f1c&"
import script from "./VisorEvidencia.vue?vue&type=script&lang=js&"
export * from "./VisorEvidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports